import {Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {
    @Input() public selected: any;
    @Input() public range: any[] = [];
    @Input() public icon: string;
    @Input() public color = 'brn-secondary';
    @Input() public needConvert = false;
    @Input() public data: any[];

    @Output() public selectEmit: EventEmitter<any> = new EventEmitter<any>();

    rangeCopy: any[];

    constructor() {
    }

    ngOnInit(): void {
    }

    selectItem(item: any): void {
        this.selectEmit.emit(item);
    }

    search(text: string): void {
        this.range = this.searchByText(this.rangeCopy, text);
    }

    searchByText(range: any[], searchText: string): any[] {
        let filteredRange: any[];
        if (searchText) {
            filteredRange = range.filter(x => {
                const fullName = x.toString();
                const association = (data: string, searchFromStart = false) => {
                    if (searchFromStart) {
                        return data.toLowerCase().indexOf(searchText.toLowerCase()) === 0;
                    }
                    return data.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
                };
                if (association(fullName) || x && association(x.toString(), true)) {
                    return x;
                }
            });
        } else {
            filteredRange = range;
        }
        return filteredRange;
    }

    scrollToSelect(scrollContainer: HTMLElement): void {
        if (!this.range.length) {
            if (this.needConvert) {
                for (let i = this.data[0]; i <= this.data[1]; i++) {
                    this.range.push(i);
                }
            }
            this.rangeCopy = structuredClone(this.range);
        }

        setTimeout(() => {
            scrollContainer.scrollTop = 32 * (Number(this.selected) - 1);
        });
    }

    scrollToTop(e: MouseEvent, scrollContainer: HTMLElement, toTop: boolean): void {
        e.stopPropagation();
        e.preventDefault();
        if (toTop) {
            scrollContainer.scrollTop = 0;
        } else {
            scrollContainer.scrollTop = scrollContainer.scrollHeight;
        }
    }
}
